import { z } from 'zod';
import { CommentEntityTypeSchema } from './enums.js';

export const CommentSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  userName: z.string(),
  entityType: CommentEntityTypeSchema,
  entityId: z.string().uuid(),
  body: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type CommentDto = z.infer<typeof CommentSchema>;

export const CommentListQuerySchema = z.object({
  entityType: CommentEntityTypeSchema,
  entityId: z.string().uuid(),
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type CommentListQuery = z.infer<typeof CommentListQuerySchema>;

export const CommentCreateInputSchema = z
  .object({
    entityType: CommentEntityTypeSchema,
    entityId: z.string().uuid(),
    body: z.string().min(1, 'Comment body required').max(5000, 'Comment body too long'),
  })
  .strict();
export type CommentCreateInput = z.infer<typeof CommentCreateInputSchema>;

export const CommentUpdateInputSchema = z
  .object({
    body: z.string().min(1, 'Comment body required').max(5000, 'Comment body too long'),
  })
  .strict();
export type CommentUpdateInput = z.infer<typeof CommentUpdateInputSchema>;
